// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3P7J4","selected":"Chip_selected__1FLBA"};